import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { DashboardReference } from '@loyalty/shared-common/report-api-client';
import { LuzmoDashboardComponent } from '@luzmo/react-embed';
import { LuzmoEmbedDashboard } from '@luzmo/embed';
import { QlfPlaceholder } from '@qualifio/ui-commons';
import { Skeleton } from '@mui/material';
import { extractErrorMessage } from '@loyalty/shared-common';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { QlfMasterDetailContainer } from '../shared/layout/QlfMasterDetailContainer';
import { useApi } from '../shared/api-client/ApiClientProvider';
import { useProgram } from '../loyalty/ProgramContext';

const useStyles = makeStyles({
  dashboard: {
    width: 1400,
    maxWidth: 'calc(100% - 48px)',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
  },
});

export function ReportDashboard(): ReactElement {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const { program } = useProgram();
  const [loading, setLoading] = useState(true);
  const dashboardInstance = useRef<LuzmoEmbedDashboard | null>(null);
  const [reference, setReference] = useState<DashboardReference>();
  const [error, setError] = useState<Error>();
  const { reportApi } = useApi();

  useEffect(() => {
    setLoading(true);
    reportApi
      .getDashboardReference(program.id)
      .then(setReference)
      .catch(err => {
        setError(err);
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (error) {
    return (
      <QlfPlaceholder
        primaryText={t('report.error.loading')}
        helpText={extractErrorMessage(error)}
      />
    );
  }

  return (
    <QlfMasterDetailContainer>
      {loading ? (
        <Skeleton className={classes.dashboard} />
      ) : (
        <LuzmoDashboardComponent
          appServer="https://app.cumul.io/"
          ref={dashboardInstance}
          className={classes.dashboard}
          dashboardId={reference?.dashboardId}
          authKey={reference?.key}
          authToken={reference?.token}
          switchScreenModeOnResize={true}
          loaderBackground={'white'}
          language={i18n.language}
        />
      )}
    </QlfMasterDetailContainer>
  );
}
